import { OrderStatus } from "../generated/graphql";

export const LIMIT_PAGINATION_QUANTITY = 20;

export enum ORDER_NOTES {
  RUSH = "RUSH",
  PHYSICAL_PRINT = "PHYSICAL PRINT",
  COMMENT = "COMMENT",
  IMPLANT = "IMPLANT",
  NO_ATTACHMENT = "NO ATTACHMENT",
  PAC = "PAC",
  REDO = "REDO",
  COMMUNICATE = "COMMUNICATE",
  MEDITLINK = "MEDITLINK",
}

export const PROVIDER_ALLOWED_STATUSES: OrderStatus[] = [
  OrderStatus.Producing,
  OrderStatus.ProducingInTransit,
  OrderStatus.OnHold,
];

export const TO_SHIP_STATUSES: OrderStatus[] = [
  OrderStatus.WaitingForProduction,
  OrderStatus.Producing,
  OrderStatus.OnHold,
];

export const INBOX_STATUSES: OrderStatus[] = [
  OrderStatus.Confirmed,
  OrderStatus.NeedToBeProcessed,
];

export type ToShipStatus = (typeof TO_SHIP_STATUSES)[number];
